var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgECardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33341 3.33325C2.40841 3.33325 1.66675 4.07492 1.66675 4.99992V14.9999C1.66675 15.9249 2.40841 16.6666 3.33341 16.6666H16.6667C17.5917 16.6666 18.3334 15.9249 18.3334 14.9999V4.99992C18.3334 4.07492 17.5917 3.33325 16.6667 3.33325H3.33341ZM3.33341 4.99992H16.6667V8.33325H3.33341V4.99992ZM3.33341 9.99992H6.66675V11.6666H3.33341V9.99992ZM8.33342 9.99992H16.6667V11.6666H8.33342V9.99992ZM3.33341 13.3333H11.6667V14.9999H3.33341V13.3333ZM13.3334 13.3333H16.6667V14.9999H13.3334V13.3333Z",
    fill: "#C7222A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgECardIcon);
export default __webpack_public_path__ + "static/media/e-card-icon.2ad5d1821caa57532421603a227cce9f.svg";
export { ForwardRef as ReactComponent };